import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const exportRecoverConversations = unaryRpc({
  name: "exportRecoverConversations",
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    inboundCsv: z.string(),
    threadsJson: z.string(),
    inboundCount: z.number(),
    threadCount: z.number(),
    conversationCount: z.number(),
  }),
});
